import React from 'react';
import styles from './AuthChoice.module.css';
import logo from '../../assets/pic/TokPlan.png';
import BackgroundPattern from '../../components/Landing/BackgroundPattern';
import kakao from '../../assets/oauth/카톡.png';
import google from '../../assets/oauth/구글.png';
import StartButton from '../../components/Landing/StartButton';
import Snow from '../../components/Landing/Snow';
import { OAUTH_BASE_URL } from '../../apis/api';


const AuthChoice = () => {
    const handleSocialLogin = (provider) => {
        // 로컬/배포 환경에 따라 돌아올 프론트 주소가 달라야 함
        // (백엔드가 redirect_uri 파라미터를 지원해야 동작)
        const redirectUri = `${window.location.origin}/home`;
        window.location.href = `${OAUTH_BASE_URL}/oauth2/authorization/${provider}?redirect_uri=${encodeURIComponent(redirectUri)}`;
    };

    return (
        <div className={styles.container}>
            {/* 배경 패턴 및 로고 */}
            <BackgroundPattern />
            <Snow />

            <img src={logo} alt="TokPlan Logo" className={styles.logo} />

            <div className={styles.contentWrapper}>
                {/* 로그인/회원가입 버튼 */}
                <div className={styles.buttonGroup}>
                    <StartButton
                        to="/login?force=1"
                        text="로그인"
                        style={{ width: '270px', height: '61px', justifyContent: 'space-between' }}
                        arrowStyle={{ width: '40px', height: '40px' }}
                    />
                    <StartButton
                        to="/signup"
                        text="회원가입"
                        style={{ width: '270px', height: '61px', justifyContent: 'space-between' }}
                        arrowStyle={{ width: '40px', height: '40px' }}
                    />
                </div>

                {/* 소셜 로그인 버튼 */}
                <div className={styles.socialGroup}>
                    <button
                        className={styles.socialBtn}
                        style={{ backgroundColor: '#FEE500' }}
                        onClick={() => handleSocialLogin('kakao')}
                    >
                        <img src={kakao} alt="Kakao" />
                    </button>
                    <button
                        className={styles.socialBtn}
                        style={{ backgroundColor: '#FFFFFF' }}
                        onClick={() => handleSocialLogin('google')}
                    >
                        <img src={google} alt="Google" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AuthChoice;
